import * as ng from 'angular';
import {ComponentRegistration} from '../../core';
import {ISessionService, IToastMessageService} from '../../services';
import {Dto, ICreditCardResource, IProfileResource} from '../../data';
import {CreditCardControlState} from "../../user-controls/credit-card-control-state";

let template = require('./account-info.html');

class AccountInfoComponent extends ComponentRegistration {

    constructor() {
        super('accountInfo', {
            controller: AccountInfoController,
            templateUrl: template,
            controllerAs: 'accountInfo',
            bindings: {
            }
        });
    }
}

interface IAccountInfoController {
    onCancel(args): void;
    onSave(args): void;
    onEdit(args): void;
    setFormReadOnly(): void;
    loadAccount(accountId): void;
    saveAccount(args): ng.IPromise<void>;
    savePrimaryContact(args): ng.IPromise<any>;
    onCreditCardTokenReceived(args: any): ng.IPromise<any>;
}

class AccountInfoController implements IAccountInfoController {
    private static $inject: Array<string> = ['$window', '$rootRouter', 'Session', 'CreditCard', 'toastMessageFactory', 'Profile'];

    private sessionRef: any = {};

    private account: Dto.IAccount;

    private activities: any = [];
    private primaryCreditCard: any = {};

    private primaryContact: any = {};

    private isReadOnly: Boolean = true;
    private creditCardControlState: CreditCardControlState = CreditCardControlState.ReadMode;

    private oriAccount: any = {};
    private oriPrimaryContact: any = {};
    private oriPrimaryCreditCard: any = {};

    private accountInfoForm: ng.IFormController;

    constructor(private $window: ng.IWindowService,
        private $router: ng.Router,
        private Session: ISessionService,
        private CreditCard: ICreditCardResource,
        private toastMessageFactory: IToastMessageService,
        private Profile: IProfileResource) {
    }

    public $onInit(): void {
        if(!this.Session.assureActiveUserSession()) return;
        console.log('AccountInfoController loaded');
        this.setFormReadOnly();
        this.loadAccount();
        console.log('AccountInfoController activated');
    }

    public $onDestroy(): void {
        this.sessionRef = {};
        this.account = {} as Dto.IAccount;
        this.primaryContact = {};
        this.primaryCreditCard = {};
        this.oriAccount = {};
        this.oriPrimaryContact = {};
        this.oriPrimaryCreditCard = {};
    }

    public onCancel(args): void {
        this.account = ng.copy(this.oriAccount);
        this.creditCardControlState = CreditCardControlState.ReadMode;
        this.primaryContact = ng.copy(this.oriPrimaryContact);
        this.primaryCreditCard = ng.copy(this.oriPrimaryCreditCard);
        this.accountInfoForm.$setPristine();
        this.accountInfoForm.$setUntouched();
        this.sessionRef.account = this.account;
        this.setFormReadOnly();
    }

    public onSave(args): void {
        this.saveAccount(args);
    }

    public onEdit(args): void {
        this.isReadOnly = false;
    }

    public setFormReadOnly(): void {
        this.isReadOnly = true;
        this.creditCardControlState = CreditCardControlState.ReadMode;
    }

    public loadAccount(accountId?: string): void {
        this.Session.getSessionAsync()
            .then((session) => {
                this.sessionRef = session;
                this.account = session.account;
                this.primaryContact = session.account.primaryContact;
                this.primaryCreditCard = session.account.primaryCreditCard;
                this.oriAccount = ng.copy(this.account);
                this.oriPrimaryContact = ng.copy(this.primaryContact);
                this.oriPrimaryCreditCard = ng.copy(this.account.primaryCreditCard);
            });
    }

    public saveAccount(args): ng.IPromise<void> {

        this.setFormReadOnly();
        this.primaryContact.securityQuestion = null;
        return this.account.$update()
            .then((response) => {
                this.primaryContact.username = this.primaryContact.email;
                this.savePrimaryContact(args);
            })
            .catch((e) => {
                args.cancel();
                this.isReadOnly = false;
                console.log(e);
            })
            .finally(() => {

            });
    }

    public savePrimaryContact(args): ng.IPromise<any> {
        return this.Profile.update({ id: this.primaryContact.id, accountId: this.account.id }, this.primaryContact)
            .$promise
            .then((response) => {
                this.toastMessageFactory.showSuccessMessage();
                console.log("Account Save Successful");
                console.log('Successful Primary Contact save to API, Account Id: ' + this.account.id);
            })
            .catch((e) => {
                args.cancel();
                this.isReadOnly = false;
                console.log(e);
            })
            .finally(() => {
                this.Session.reload()
                    .then((session) => {
                        this.sessionRef = session;
                        this.account = session.account;
                        this.primaryContact = session.account.primaryContact;
                        this.primaryCreditCard = session.account.primaryCreditCard;
                        this.oriAccount = ng.copy(this.account);
                        this.oriPrimaryContact = ng.copy(this.primaryContact);
                        this.oriPrimaryCreditCard = ng.copy(this.account.primaryCreditCard);
                    });
            });
    }

    public onCreditCardTokenReceived(args: any): ng.IPromise<any> {
        this.updateCreditCardInfo(args);

        return this.CreditCard.update({ id: this.account.primaryCreditCard.id, accountId: this.account.id }, this.account.primaryCreditCard)
            .$promise
            .then((response) => {
                this.toastMessageFactory.showSuccessMessage();
                // oriAccount = angular.copy(accountInfo.account);
            })
            .catch((e) => {
                console.log(e);
            })
            .finally(() => {

            });
    }

    private updateCreditCardInfo(creditCard: Dto.ICreditCard) {
        this.account.primaryCreditCard.creditCardType = creditCard.creditCardType;
        this.account.primaryCreditCard.expirationMonth = creditCard.expirationMonth;
        this.account.primaryCreditCard.expirationYear = creditCard.expirationYear;
        this.account.primaryCreditCard.maskedCreditCard = creditCard.maskedCreditCard;
        this.account.primaryCreditCard.token = creditCard.token;
    }
}

let acctinfComponent = new AccountInfoComponent();
export default acctinfComponent;
export { acctinfComponent as AccountInfoComponent, IAccountInfoController, AccountInfoController }


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./app/components/dashboard/account-info.ts